import { render, staticRenderFns } from "./canadaPost.vue?vue&type=template&id=351e06e3&scoped=true"
import script from "./canadaPost.vue?vue&type=script&lang=js"
export * from "./canadaPost.vue?vue&type=script&lang=js"
import style0 from "./canadaPost.vue?vue&type=style&index=0&id=351e06e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e06e3",
  null
  
)

export default component.exports